import { useParams } from "react-router-dom";
import { TextMessageList } from "@/business-settings/text-messages/text-message-list";
import { useGetInboundTextMessages } from "@/text-messages/query";

export const ConversationMessages = () => {
  const { businessId } = useParams();
  const {
    data: inboundMessages,
    isLoading,
    isError,
    refetch,
  } = useGetInboundTextMessages(businessId);

  return (
    <TextMessageList
      textMessages={inboundMessages}
      isLoading={isLoading}
      isError={isError}
      onRetry={() => void refetch()}
      emptyMessage="No inbound messages yet"
    />
  );
};
